import React, { memo } from 'react';
import { BarChart, XAxis, Bar, Tooltip, ResponsiveContainer } from 'recharts';
import moment from 'moment';
import AnnouncementPollForm from './AnnouncementPollForm';
import './announcement.scss';
import { TwitterTimelineEmbed } from 'react-twitter-embed';
import { Badge, Card } from '../../../ui-kit';
import { IconEdit, IconBullhorn } from '../../../ui-kit/icons';

const PollBarChart = memo(({ poll }) => {
  const pollVotes = poll.answers.map(answer => ({
    value: answer.voter_ids.length,
    label: answer.answer
  }));

  return (
    <ResponsiveContainer width="100%" height={150}>
      <BarChart data={pollVotes} margin={{ top: 5, bottom: 5 }}>
        <XAxis dataKey="label" />
        <Tooltip />
        <Bar dataKey="value" fill="#82ca9d" />
      </BarChart>
    </ResponsiveContainer>
  );
});
PollBarChart.displayName = 'PollBarChart';

const Announcement = ({ announcement, displayDetails, editRights, editAnnouncement }) => {
  var re = new RegExp(String.raw`((https://)|(www\.))twitter\.com/(\w+)`);
  const twitterUsernamePresent = String(announcement.content).match(re);
  const { poll } = announcement;

  const hasVotes = () => {
    if (!poll) return false;
    return poll.answers.some(answer => answer.voter_ids.length > 0);
  };

  return (
    <Card className={announcement.system_announcement ? 'system-announcement' : ''}>
      <Card.Header>
        {announcement.system_announcement && <IconBullhorn />} <strong>{announcement.subject}</strong>
        {editRights && !announcement.system_announcement && (
          <IconEdit title={I18n.t('edit')} className="float-right" onClick={() => editAnnouncement(announcement)} />
        )}
      </Card.Header>
      <Card.Body className="py-2">
        {twitterUsernamePresent ? (
          <TwitterTimelineEmbed
            sourceType="profile"
            screenName={twitterUsernamePresent[4]}
            options={{ height: 450, width: 450 }}
          />
        ) : (
          <div className="announcement-content" dangerouslySetInnerHTML={{ __html: announcement.content }} />
        )}
        {announcement.attachments.length > 0 && (
          <ul className="fa-ul small mt-2">
            {announcement.attachments.map((attachment, index) => (
              <li key={index}>
                <span className="fa-li">
                  <i className="fa fa-paperclip" />
                </span>
                <a href={attachment.url} target="_blank" rel="noreferrer">
                  {attachment.file_name}
                </a>
              </li>
            ))}
          </ul>
        )}

        {poll && <AnnouncementPollForm poll={poll} />}
        {poll && hasVotes() && <PollBarChart poll={poll} />}
        <Badge variant={announcement.system_announcement ? 'danger' : 'secondary'}>
          {displayDetails && announcement.creator_name}
        </Badge>
        {displayDetails && (
          <small className="text-body-secondary fw-light float-right">
            {moment(announcement.created_at).format('DD/MM/YYYY')}
          </small>
        )}
      </Card.Body>
    </Card>
  );
};

export default Announcement;
